import { TypedResource } from 'src/services/api-client/resource/base/TypedResource';
import UserResource from 'src/services/api-client/resource/UserResource';
import Project from 'src/entities/Project';
import AptitudeTest from 'src/entities/AptitudeTest';
import FilledAptitudeTestResource from 'src/services/api-client/resource/FilledAptitudeTestResource';
import Metrics from 'src/entities/Metrics';
import FileResource from 'src/services/api-client/resource/FileResource';
import Resource from 'src/services/api-client/resource/base/Resource';
import ConstantsResource from 'src/services/api-client/resource/ConstantsResource';
import InvestorType from 'src/entities/InvestorType';
import ProjectComment from 'src/entities/ProjectComment';
import JuridicalPerson, { JuridicalPersonProperties } from 'src/entities/JuridicalPerson';
import PhysicalPerson, { PhysicalPersonProperties } from 'src/entities/PhysicalPerson';
import PaymentResource from 'src/services/api-client/resource/PaymentResource';
import ContractCorrections from 'src/value-objects/ContractCorrections';
import Company from 'src/entities/Company';
import InvestorDeck from 'src/entities/InvestorDeck';
import Person from 'src/entities/Person';
import ProjectTeamMemberResource from 'src/services/api-client/resource/ProjectTeamMemberResource';
import OfflineInvestorResource from 'src/services/api-client/resource/OfflineInvestorResource';
import Investment from 'src/entities/Investment';
import HomeBanner from 'src/entities/HomeBanner';
import Testimonial from 'src/entities/Testimonial';

class ApiClientSingleton {
  private static _instance: ApiClientSingleton;

  public readonly childComment: Resource;
  public readonly checkUserPassword: Resource;
  public readonly constants: ConstantsResource;
  public readonly filledAptitudeTest: FilledAptitudeTestResource;
  public readonly login: Resource;
  public readonly file: FileResource;
  public readonly investment: TypedResource<Investment>;
  public readonly juridicalPerson: TypedResource<JuridicalPersonProperties>;
  public readonly metrics: TypedResource<Metrics>;
  public readonly projectComment: TypedResource<ProjectComment>;
  public readonly projectInvested: TypedResource<Person>;
  public readonly physicalPerson: TypedResource<PhysicalPersonProperties>;
  public readonly investorType: TypedResource<InvestorType>;
  public readonly project: TypedResource<Project>;
  public readonly company: TypedResource<Company>;
  public readonly projectInterested: TypedResource<Person>;
  public readonly projectCapTable: Resource;
  public readonly register: Resource;
  public readonly passwordRecovery: Resource;
  public readonly passwordReset: Resource;
  public readonly aptitudeTest: TypedResource<AptitudeTest>;
  public readonly user: UserResource;
  public readonly userInterestedProjects: Resource;
  public readonly personInterestedProjects: TypedResource<Project>;
  public readonly personInvestedProjects: TypedResource<Project>;
  public readonly userJuridicalPersons: TypedResource<JuridicalPersonProperties>;
  public readonly payment: PaymentResource;
  public readonly contractCorrections: TypedResource<ContractCorrections>;
  public readonly projectTeamMember: ProjectTeamMemberResource;
  public readonly offlineInvestor: OfflineInvestorResource;
  public readonly investorDeck: TypedResource<InvestorDeck>;
  public readonly projectDueDiligence: Resource;
  public readonly contactForm: Resource;
  public readonly physicalPersonMetrics: Resource;
  public readonly juridicalPersonMetrics: Resource;
  public readonly changeAmount: Resource;
  public readonly checkUserProfile: Resource;
  public readonly homeBanner: TypedResource<HomeBanner>;
  public readonly testimonial: TypedResource<Testimonial>;

  private constructor() {
    this.checkUserPassword = new Resource('/users/check/');
    this.childComment = new Resource('/comments/:commentId/child-comments');
    this.constants = new ConstantsResource();
    this.filledAptitudeTest = new FilledAptitudeTestResource();
    this.juridicalPerson = new TypedResource('/juridical-persons/', JuridicalPerson);
    this.file = new FileResource();
    this.investment = new TypedResource('/investments/', Investment);
    this.login = new Resource('/login/');
    this.metrics = new TypedResource('/metrics/', Metrics);
    this.physicalPerson = new TypedResource('/physical-persons/', PhysicalPerson);
    this.investorType = new TypedResource(
      '/persons/:id/investor-type',
      InvestorType
    );
    this.project = new TypedResource('/projects/', Project);
    this.company = new TypedResource('/companies/', Company);
    this.projectCapTable = new Resource('/projects/:id/cap-table');
    this.projectComment = new TypedResource('/projects/:projectId/comments', ProjectComment);
    this.projectInvested = new TypedResource('/projects/:projectId/investors', Person);
    this.projectInterested = new TypedResource('/projects/:projectId/interested', Person);
    this.register = new Resource('/register/');
    this.passwordRecovery = new Resource('/password-reset/');
    this.passwordReset = new Resource('/password-reset/reset');
    this.aptitudeTest = new TypedResource('/aptitude-tests/', AptitudeTest);
    this.user = new UserResource();
    this.personInterestedProjects = new TypedResource('/persons/:personId/interested-projects', Project);
    this.personInvestedProjects = new TypedResource('/persons/:personId/invested-projects', Project);
    this.userJuridicalPersons = new TypedResource('/users/:userId/juridical-persons', JuridicalPerson);
    this.payment = new PaymentResource();
    this.contractCorrections =
      new TypedResource('/investments/:investmentId/contract-corrections', ContractCorrections);
    this.projectTeamMember = new ProjectTeamMemberResource();
    this.offlineInvestor = new OfflineInvestorResource();
    this.investorDeck = new TypedResource('/investor-deck/', InvestorDeck);
    this.projectDueDiligence = new Resource('/projects/:id/due-diligence');
    this.contactForm = new Resource('/contact-form/');
    this.physicalPersonMetrics = new Resource('/physical-persons/:id/metrics');
    this.juridicalPersonMetrics = new Resource('/juridical-persons/:id/metrics');
    this.changeAmount = new Resource('/investments/:investmentId/change-amount');
    this.checkUserProfile = new Resource('/persons/required-profile-test/');
    this.homeBanner = new TypedResource('/home-banner/', HomeBanner);
    this.testimonial = new TypedResource('/testimonials/', Testimonial);
  }

  public static get instance(): ApiClientSingleton {
    return this._instance || (this._instance = new this());
  }
}

const ApiClient: ApiClientSingleton = ApiClientSingleton.instance;

export default ApiClient;



// WEBPACK FOOTER //
// ./src/services/api-client/ApiClient.tsx